import { render, staticRenderFns } from "./BlackGoldGames.vue?vue&type=template&id=c2fda046"
import script from "./BlackGoldGames.vue?vue&type=script&lang=js"
export * from "./BlackGoldGames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports